module.exports = __webpack_public_path__ + "img/images-line.221d45a2.svg";